<template>
  <div :class="{ active: opened.length > 0 }" class="side-box">
    <span class="side-box__overlay" />
    <div
      v-if="usage !== undefined"
      :class="{
        opened: opened.indexOf('showUsage') >= 0,
        'last-active': opened.indexOf('showUsage') === opened.length - 1
      }"
      class="side-box__inner"
    >
      <div class="side-box__header d-flex justify-content-between align-items-center">
        <div class="atom-back atom-back--gray" @click="closeBox('showUsage')">
          <div class="atom-back__inner d-flex align-items-center">
            <img src="@/assets/icons/arrows/arr-gray-left.svg" />
            <span>{{ $t("zpet") }}</span>
          </div>
        </div>
      </div>
      <div class="side-box__title">
        <h2>
          <span>{{ usage.usage?.iccid }}</span>
        </h2>
      </div>
      <div class="side-box__content">
        <div class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label text gray-text">{{ $t("datum") }}</span>
          <span class="side-box__content__value ml-3" v-html="$filters.timestampToDateTime(usage.usage?.dateTime)" />
        </div>
        <div class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label text gray-text">{{ $t("SERVICE_TYPE") }}</span>
          <span class="side-box__content__value ml-3" v-html="usage.usage?.serviceType" />
        </div>
        <div class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label text gray-text">{{ $t("AMOUNT") }}</span>
          <span class="side-box__content__value ml-3" v-html="usage.usage?.amount" />
        </div>
        <div class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label text gray-text">{{ $t("ICCID") }}</span>
          <span class="side-box__content__value ml-3" v-html="usage.usage?.iccid" />
        </div>
        <div class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label text gray-text">{{ $t("IMSI") }}</span>
          <span class="side-box__content__value ml-3" v-html="usage.usage?.imsi" />
        </div>
        <div class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label text gray-text">{{ $t("INCOMING") }}</span>
          <span v-if="usage.usage?.incoming" class="side-box__content__value ml-3">{{ $t("YES") }}</span>
          <span v-else class="side-box__content__value ml-3">{{ $t("NO") }}</span>
        </div>
        <div class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label text gray-text">{{ $t("INTERNATIONAL") }}</span>
          <span v-if="usage.usage?.international" class="side-box__content__value ml-3">
            {{ $t("YES") }}
          </span>
          <span v-else class="side-box__content__value ml-3">
            {{ $t("NO") }}
          </span>
        </div>
        <div class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label text gray-text">{{ $t("MSISDN") }}</span>
          <span class="side-box__content__value ml-3" v-html="usage.usage?.msisdn" />
        </div>
        <div class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label text gray-text">{{ $t("ROAMING") }}</span>
          <span v-if="usage.usage?.roaming" class="side-box__content__value ml-3">{{ $t("YES") }}</span>
          <span v-else class="side-box__content__value ml-3">
            {{ $t("NO") }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    device: Object,
    deviceType: String,
    item: Object,
    opened: Array
  },
  data() {
    return {
      usage: {},
      loading: false
    }
  },
  watch: {
    item() {
      this.loadData()
    }
  },
  mounted() {
    this.usage = this.item
    this.loadData()
  },
  methods: {
    closeBox(box) {
      if (box == undefined) {
        this.resetValues()
        this.$emit("closeBox")
      } else {
        //this.errors.group = "";
        this.resetValues()
        this.$emit("closeBox", box)
      }
    },
    loadData() {
      console.log(this.item, "USAAAAAAAAAAGE")
      this.loading = false
      this.usage = {}
      this.usage = this.item
    },
    resetValues() {}
  }
}
</script>

<style lang="scss" scoped>
.warning {
  color: #ef7979;
}
</style>
